import type { SVGProps } from 'react';
import type { SVGRType } from '../types';

const SvgChevronArrow = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRType) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 24 24'
    width='24'
    height='24'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M6.29476 13.345L11.1419 8.38646C11.4105 8.1179 11.679 8 12 8C12.3275 8 12.6026 8.12445 12.8581 8.38646L17.7052 13.345C17.9017 13.5415 18 13.7773 18 14.0655C18 14.6485 17.5349 15.1201 16.9585 15.1201C16.6769 15.1201 16.4017 15.0087 16.1921 14.786L12.0066 10.4694L7.81441 14.786C7.59825 15.0022 7.32969 15.1201 7.04148 15.1201C6.46507 15.1201 6 14.6485 6 14.0655C6 13.7838 6.09825 13.5415 6.29476 13.345Z' />
  </svg>
);

export default SvgChevronArrow;
